import { createSlice } from "@reduxjs/toolkit";

export const wineMakingSlice = createSlice({
    name: 'wineMaking',
    initialState: [],
    reducers: {
        emptyWineMaking: state => {
            return []
        },
        setWineMaking: (state, action) => {
            if (Array.isArray(action?.payload)) {
                return action.payload
            }
            // return action.payload
        },
        addWineMaking: (state, action) => {
            return [...state, action.payload]
            // return []
        },
        updateWineMaking: (state, action) => {
            const foundedIndex = state.findIndex((p) => Number(p.id) === Number(action.payload?.id));
            if (foundedIndex !== -1) {
                // Directly mutate the state at the found index
                state[foundedIndex] = { ...state[foundedIndex], ...action.payload };
                return state; // This ensures the updated state is returned
            } else {
                throw new Error('WinemakingProtocol not found');
            }
        },
        removeWineMaking: (state, action) => {
            return state.filter(protocol => Number(protocol?.id) !== Number(action.payload?.id));
        }
    }
});

export const {
    setWineMaking, 
    emptyWineMaking,
    updateWineMaking,
    removeWineMaking,
    addWineMaking
} = wineMakingSlice.actions;

export default wineMakingSlice.reducer